/**
 * Password validation utility
 * Checks password against requirements and provides detailed feedback
 */

export interface PasswordRequirement {
  name: string;
  met: boolean;
  message: string;
}

export interface PasswordValidationResult {
  isValid: boolean;
  requirements: PasswordRequirement[];
}

/**
 * Validate password against requirements
 * Requirements: 8+ chars, uppercase, lowercase, number
 */
export function validatePassword(password: string): PasswordValidationResult {
  // Handle null/undefined
  const pwd = password || '';

  const requirements: PasswordRequirement[] = [
    {
      name: 'minLength',
      met: pwd.length >= 8,
      message: 'At least 8 characters',
    },
    {
      name: 'hasUppercase',
      met: /[A-Z]/.test(pwd),
      message: 'At least one uppercase letter',
    },
    {
      name: 'hasLowercase',
      met: /[a-z]/.test(pwd),
      message: 'At least one lowercase letter',
    },
    {
      name: 'hasNumber',
      met: /[0-9]/.test(pwd),
      message: 'At least one number',
    },
  ];

  const isValid = requirements.every((req) => req.met);

  return {
    isValid,
    requirements,
  };
}
